import cn from 'classnames';
import styles from './LocationMap.module.scss';
import { BACKEND_URL } from '@/constants';
import Link from 'next/link';
import { useAdaptiveWidth } from '@/hooks/useAdaptiveWidth';
import { useTranslations } from '@/hooks/useTranslations';

type LocationMapProps = {
  img: string;
  file: string;
  mobileImg: string;
  className?: string;
  title?: string;
  internal?: boolean;
};

export function LocationMap({
  img,
  file,
  mobileImg,
  className,
  title,
  internal,
}: LocationMapProps) {
  const locationClassName = cn(styles.location, className);
  const fileLink = file ? `${BACKEND_URL}${file}` : `${BACKEND_URL}${img}`;
  const { isMobile } = useAdaptiveWidth();
  const translations = useTranslations();

  return (
    <div className={cn(locationClassName, 'custom-map')}>
      <h3 className={cn(styles.title, 'custom-map-title')}>
        {title ?? translations.map ?? translations.map}
      </h3>
      <Link href={fileLink} target={internal ? undefined : '_blank'}>
        <img
          loading="lazy"
          src={`${BACKEND_URL}${isMobile && mobileImg ? mobileImg : img}`}
          alt="location"
          className={styles.img}
        />
      </Link>
    </div>
  );
}
